<template>
  <div class='container'>
    <div class='row nav'>
      <div class='col-sm-12'>
        <router-link to="/about" class='my-tools' >小工具</router-link>
        <router-link v-if="!$cookies.get('username')" to="/login" >登录</router-link>
        <router-link v-if="$cookies.get('username')" to="/changepsw" >修改密码</router-link>|
        <router-link to="/" >添加</router-link> |
        <router-link to="/list" >列表</router-link>
        
        <!-- <router-link to="/turnTable" >转盘</router-link> | -->
      </div>
      <br/><br/>
      <!-- <div class="col-md-12 text-center" >
        <img class="my-logo" alt="Vue logo" src="./assets/logo.png">
      </div> -->
    </div>
    <router-view/>
    <br><hr><br>
    <div class='row footer'>
      <div class='col-sm-12'>
        <p class='text-center'><a href="https://beian.miit.gov.cn/">鄂ICP备2025162315号-1</a></p>
      </div>
    </div>
  </div>
</template>

<style lang="less">
#app {
  color: #2c3e50;
}

.nav{
  text-align: right;
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
}

.input-group{
  margin-bottom: 20px;
}

.my-logo{
  width:100px;
  margin-bottom: 20px;
}

.my-tools{
  float:left;
}
</style>


